import React from "react";
import star from "../../assets/star-5.svg";
import profileImg from "../../assets/mypic-2.png";

const MoreAboutSection = () => {
  return (
    <div className="py-10 md:py-20 px-5 md:px-10">
      <div className="flex flex-col md:flex-row gap-10 items-center">
        <div className="w-full md:w-1/3">
          <img src={profileImg} className="w-full" alt="Profile" />
        </div>
        <div className="w-full md:w-3/4  rounded-lg border-[1px] border-neutral-700">
          <div className="p-5">
            <div className="flex flex-row items-center gap-2 mb-3">
              <img src={star} className="w-5" alt="Star icon" />
              <p className="text-lg font-semibold my-3">Engineering + Product + People</p>
            </div>
            <p className="font-light leading-8 tracking-tight">
            I'm a software engineer who enjoys turning complex ideas into intelligent, usable and accessible products. I combine engineering, product thinking and human-centered design to build solutions that are technically sound, intuitive to use and grounded in real needs. <span className="font-medium">For me, writing code is part of a larger responsibility: making complexity easier to navigate and delivering products that create meaningful value.</span>
            </p>
            <p className="font-light leading-8 tracking-tight mt-3">
            I'm currently helping redefine the vehicle repair experience at <a className="underline" href='https://www.balancee.app' target="_blank" rel="noopener noreferrer">Balanceè</a>. I'm also an ambassador with <a className="underline" href='https://developers.google.com/womentechmakers' target="_blank" rel="noopener noreferrer">Google's Women Techmakers</a>, where I mentor aspiring women in technology as they build the skills to grow in the industry. Previously, I worked at <a className="underline" href='https://www.chevron.com/' target="_blank" rel="noopener noreferrer">Chevron</a>. Outside work, you'll find me exploring the city, trying new recipes, singing or getting lost in a good book. I'm always open to meaningful collaborations, so feel free to reach out.
            </p>
            
            
          </div>
          {/* <hr className="my-10 h-[1px] border-neutral-700"/>
          <div className="p-7 pt-0">
            <p>Contact Information</p>
            <div className="grid grid-cols-2 w-full">
            <div>
              <p>Email</p>
              <p>hi@maryojo.me</p>
            </div>
            <div>
              <p>Phone</p>
              <p>emaksj</p>
            </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default MoreAboutSection;
